import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper, ClaimSection, ClaimTemplate, ClaimToken, ServiceType } from "@framework/shared";

export const claimRoutes: Array<RouteObject> = [
  {
    path: "/claims",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="claims">
            <ClaimSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/claims/templates",
        element: <Protected />,
        children: [
          { index: true, element: <ClaimTemplate service={ServiceType.ADMIN} /> },

          { path: "/claims/templates/:id/:action", element: <ClaimTemplate service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/claims/tokens",
        element: <Protected />,
        children: [
          { index: true, element: <ClaimToken service={ServiceType.ADMIN} /> },
          { path: "/claims/tokens/:id/:action", element: <ClaimToken service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
